import { render, staticRenderFns } from "./proposed-loan-section.vue?vue&type=template&id=3c65be8c&scoped=true&"
import script from "./proposed-loan-section.vue?vue&type=script&lang=ts&"
export * from "./proposed-loan-section.vue?vue&type=script&lang=ts&"
import style0 from "./proposed-loan-section.vue?vue&type=style&index=0&id=3c65be8c&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3c65be8c",
  null
  
)

export default component.exports